// Logo oficial Skycover by Eclipse Cubiertas (PNG con alpha transparente real).
// El archivo viene con azul corporativo #1a4379 ya correcto — NO requiere filter de boost.
export default function SkycoverLogo({ className = "h-9 sm:h-10 w-auto", alt = "Skycover by Eclipse Cubiertas" }) {
    return (
        <img
            src="/brand/skycover_logo.png"
            alt={alt}
            className={`${className} object-contain`}
            loading="eager"
            decoding="async"
            data-testid="skycover-logo"
        />
    );
}
